var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignSectionBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3464.93 2546.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f7;}.cls-10,.cls-12,.cls-13,.cls-14,.cls-2,.cls-4,.cls-5,.cls-6,.cls-8,.cls-9{opacity:0.2;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-8);}.cls-11{fill:url(#linear-gradient-9);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:url(#linear-gradient-11);}.cls-14{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1384.82,
    y1: 671.82,
    x2: 1432.69,
    y2: 719.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e1e1e1",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#acacac",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#7e7e7e",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#575757",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#383838",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#1f1f1f",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0e0e0e",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1484.29,
    y1: 770.31,
    x2: 1448.77,
    y2: 734.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1854.32,
    y1: 817.55,
    x2: 1818.69,
    y2: 781.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1756.4,
    y1: 721.71,
    x2: 1792.4,
    y2: 757.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2198.89,
    y1: 1054.67,
    x2: 2238.32,
    y2: 1094.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2280.82,
    y1: 1135.79,
    x2: 2251.56,
    y2: 1106.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2585.61,
    y1: 1174.71,
    x2: 2556.27,
    y2: 1145.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2504.96,
    y1: 1095.76,
    x2: 2534.61,
    y2: 1125.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 195.45,
    y1: 229.27,
    x2: 261.17,
    y2: 294.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 332.02,
    y1: 364.49,
    x2: 283.25,
    y2: 315.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 840.08,
    y1: 429.36,
    x2: 791.17,
    y2: 380.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 705.64,
    y1: 297.76,
    x2: 755.07,
    y2: 347.19,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "designBackground") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smallStructure"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2284,152.17h0a49.06,49.06,0,0,0-69.37,0l-215,215a49.06,49.06,0,0,1-69.37,0h0a49,49,0,0,0-69.37,0l-61,61a49.06,49.06,0,0,1-69.37,0h0a49.06,49.06,0,0,1,0-69.37L1901.1,188.24a49.06,49.06,0,0,0,0-69.37h0a49.06,49.06,0,0,0-69.37,0L882.8,1067.81a49,49,0,0,0,0,69.36h0a49,49,0,0,0,69.36,0l120.7-120.7a49.06,49.06,0,0,1,69.37,0h0a49.06,49.06,0,0,1,0,69.37l-45.78,45.78a49,49,0,0,0,0,69.37h0a49.05,49.05,0,0,0,69.36,0l111-111a49.06,49.06,0,0,1,69.37,0h0a49,49,0,0,0,69.36,0l63.82-63.81a49,49,0,0,1,69.36,0h0a49,49,0,0,1,0,69.36l-285.78,285.79a49,49,0,0,0,0,69.37h0a49.05,49.05,0,0,0,69.36,0l947.55-947.55a49.05,49.05,0,0,0,0-69.36h0a49,49,0,0,0-69.37,0L2132.32,512a49,49,0,0,1-69.37,0h0a49.06,49.06,0,0,1,0-69.37l221.05-221A49.06,49.06,0,0,0,2284,152.17Z",
    transform: "translate(513.57 732)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dots"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1949.16,
    y: -28.29,
    width: 98.1,
    height: 98.1,
    rx: 49.05,
    ry: 49.05,
    transform: "translate(1084.15 2151.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1118.15,
    y: 1496.38,
    width: 98.1,
    height: 98.1,
    rx: 49.05,
    ry: 49.05,
    transform: "translate(-237.35 2009.98) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1731.45,427.25h0a49.06,49.06,0,0,1,0-69.37l8.22-8.21h0l-677,677h0l11.19-11.2a49.06,49.06,0,0,1,69.37,0h0C1147.77,1020,1735,430.81,1731.45,427.25Z",
    transform: "translate(513.57 732)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1730.45,428.25h0l-.34-.36L1143,1015l-.2,2.07a49,49,0,0,1,4.77,62.43l645.91-645.91A49.07,49.07,0,0,1,1730.45,428.25Z",
    transform: "translate(513.57 732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2063,512h0l-513.75,514.75a49,49,0,0,1-.53,68.8L2132.32,512A49.06,49.06,0,0,1,2063,512Z",
    transform: "translate(513.57 732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2063,512,2063,512h0a49,49,0,0,1-5.52-62.76v0l-573.85,573.26a49,49,0,0,1,65.14,3.76h0c.19.18.36.37.54.56L2063,512Z",
    transform: "translate(513.57 732)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mediumStructure"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2939.53,626.64h0a40.4,40.4,0,0,0-57.14,0L2705.27,803.76a40.39,40.39,0,0,1-57.13,0h0a40.42,40.42,0,0,0-57.14,0L2540.72,854a40.4,40.4,0,0,1-57.14,0h0a40.41,40.41,0,0,1,0-57.13l140.56-140.56a40.39,40.39,0,0,0,0-57.13h0a40.4,40.4,0,0,0-57.14,0l-781.62,781.62a40.4,40.4,0,0,0,0,57.14h0a40.39,40.39,0,0,0,57.13,0l99.42-99.42a40.4,40.4,0,0,1,57.14,0h0a40.42,40.42,0,0,1,0,57.14l-37.71,37.71a40.39,40.39,0,0,0,0,57.13h0a40.39,40.39,0,0,0,57.13,0l91.42-91.42a40.42,40.42,0,0,1,57.14,0h0a40.39,40.39,0,0,0,57.13,0l52.57-52.56a40.4,40.4,0,0,1,57.14,0h0a40.42,40.42,0,0,1,0,57.14l-235.41,235.4a40.41,40.41,0,0,0,0,57.13h0a40.4,40.4,0,0,0,57.14,0L2936.1,915.75a40.39,40.39,0,0,0,0-57.13h0a40.41,40.41,0,0,0-57.13,0L2814.59,923a40.39,40.39,0,0,1-57.13,0h0a40.4,40.4,0,0,1,0-57.14l182.07-182.07A40.4,40.4,0,0,0,2939.53,626.64Z",
    transform: "translate(513.57 732)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dots-2",
    "data-name": "Dots"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2663.73,
    y: 478,
    width: 80.8,
    height: 80.8,
    rx: 40.4,
    ry: 40.4,
    transform: "translate(939.02 2795.94) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1979.23,
    y: 1733.86,
    width: 80.8,
    height: 80.8,
    rx: 40.4,
    ry: 40.4,
    transform: "translate(-149.48 2679.77) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows-2",
    "data-name": "Shadows"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2484.41,853.22h0a40.4,40.4,0,0,1,0-57.14l6.76-6.76h0L1933.53,1347h0l9.22-9.22a40.4,40.4,0,0,1,57.14,0h0C2003.63,1341.48,2487.34,856.15,2484.41,853.22Z",
    transform: "translate(513.57 732)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2483.58,854h0l-.28-.29-483.6,483.6-.16,1.7a40.4,40.4,0,0,1,3.93,51.42l532-532A40.41,40.41,0,0,1,2483.58,854Z",
    transform: "translate(513.57 732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2757.5,923h0l-423.17,424a40.4,40.4,0,0,1-.44,56.67L2814.59,923A40.4,40.4,0,0,1,2757.5,923Z",
    transform: "translate(513.57 732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2757.5,923l0,0h0a40.39,40.39,0,0,1-4.55-51.7v0l-472.67,472.2a40.4,40.4,0,0,1,53.66,3.09h0l.44.46L2757.5,923Z",
    transform: "translate(513.57 732)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "bigStructure"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1430-484.23h0a67.34,67.34,0,0,0-95.24,0L1039.55-189a67.34,67.34,0,0,1-95.24,0h0a67.34,67.34,0,0,0-95.24,0l-83.81,83.82a67.36,67.36,0,0,1-95.25,0h0a67.34,67.34,0,0,1,0-95.24l234.3-234.3a67.34,67.34,0,0,0,0-95.24h0a67.34,67.34,0,0,0-95.24,0L-493.84,773a67.34,67.34,0,0,0,0,95.24h0a67.34,67.34,0,0,0,95.24,0l165.72-165.72a67.34,67.34,0,0,1,95.24,0h0a67.34,67.34,0,0,1,0,95.24l-62.86,62.86a67.34,67.34,0,0,0,0,95.24h0a67.34,67.34,0,0,0,95.24,0L47.13,803.44a67.34,67.34,0,0,1,95.24,0h0a67.34,67.34,0,0,0,95.24,0l87.63-87.63a67.34,67.34,0,0,1,95.24,0h0a67.34,67.34,0,0,1,0,95.24l-392.4,392.4a67.34,67.34,0,0,0,0,95.24h0a67.34,67.34,0,0,0,95.24,0l1301-1301a67.34,67.34,0,0,0,0-95.24h0a67.34,67.34,0,0,0-95.24,0L1221.78,9.76a67.34,67.34,0,0,1-95.24,0h0a67.34,67.34,0,0,1,0-95.24L1430-389A67.36,67.36,0,0,0,1430-484.23Z",
    transform: "translate(513.57 732)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dots-3",
    "data-name": "Dots"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -170.7,
    y: 1361.42,
    width: 134.69,
    height: 134.69,
    rx: 67.35,
    ry: 67.35,
    transform: "translate(-526.99 1077.39) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 970.3,
    y: -732,
    width: 134.69,
    height: 134.69,
    rx: 67.35,
    ry: 67.35,
    transform: "translate(1287.47 1271.05) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows-3",
    "data-name": "Shadows"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M671.39-106.54h0a67.34,67.34,0,0,1,0-95.24l11.27-11.28h0L-246.88,716.48h0l15.37-15.36a67.34,67.34,0,0,1,95.24,0h0C-130,707.36,676.28-101.64,671.39-106.54Z",
    transform: "translate(513.57 732)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M670-105.16h0c-.16-.16-.31-.33-.47-.5L-136.58,700.46l-.28,2.85A67.34,67.34,0,0,1-130.3,789L756.54-97.83A67.34,67.34,0,0,1,670-105.16Z",
    transform: "translate(513.57 732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1126.61,9.83h0L421.21,716.6a67.32,67.32,0,0,1-.73,94.46l801.3-801.3A67.34,67.34,0,0,1,1126.61,9.83Z",
    transform: "translate(513.57 732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1126.61,9.83l-.07-.07h0A67.35,67.35,0,0,1,1119-76.41v0L331,710.67a67.35,67.35,0,0,1,89.45,5.15h0l.73.78L1126.61,9.83Z",
    transform: "translate(513.57 732)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "RandomDots"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 532.3,
    y: 1226.42,
    width: 134.69,
    height: 134.69,
    rx: 67.35,
    ry: 67.35,
    transform: "translate(-225.63 1534.95) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 646.07,
    y: 1514.52,
    width: 220.5,
    height: 220.5,
    rx: 110.25,
    ry: 110.25,
    transform: "translate(-413.79 1742.68) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1885.38,
    y: 959.55,
    width: 96.42,
    height: 96.42,
    rx: 48.21,
    ry: 48.21,
    transform: "translate(367.31 2394.42) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignSectionBackground);
export default __webpack_public_path__ + "static/media/designSectionBackground.4adfdb380f649114e61e61f8ceb90567.svg";
export { ForwardRef as ReactComponent };